import { colors } from "@mosanic/styles";
import { statusAttention } from "@mosanic/styles/animations";
import styled, { css } from "styled-components";
import {layout, space} from 'styled-system';

const Dot = styled.span` 
    position: relative;
    
    ::before,
    ::after {
        content: '';
        display: block;
        top: calc(50% - 2.5px);
        height: 5px;
        width: 5px;
        border-radius: 50%;
        position: absolute;
        background: ${props => props?.active ? 
            colors.util.bright[props?.color] : 
            props.forceColor ? 
                colors.util.bright[props?.color] :
                colors.util.gray.base
        };
    }
    ${props => props.size === 'large' && css` 
        ::before,
        ::after {
            content: '';
            display: block;
            top: calc(50% - 4px);
            height: 8px;
            width: 8px;
        }
    `}
    
    ${props => (props.selected || props.active) && css`
        ${statusAttention}
        ::before {
            animation: status 1.8s ease-out infinite;
        }
    `}

    ${props => props.compact ? css` 
        ::before,
        ::after {
            left: -10px; 
        }
    ` : css` 
        padding: 0 5px;
        ::before,
        ::after {
            left: 0px; 
        }
    `}
    ${layout}
    ${space}

`

const StatusDot = ({active, compact = false, color = 'primary', ...other}) => (
    <Dot active={active} compact={compact} color={color} {...other}/>
);
export default StatusDot;